import { ItemBox } from './itemBox';

// with the top, left information, we could place the item with absolute position
interface ItemPosition {
  top: number;
  left: number;
}

export class ItemLayout {
  columnCount: number;
  columnWidth: number;
  columnPadding: number;
  rowPadding: number;
  itemCount: number;
  columnHeights: number [][];
  itemPositions: ItemPosition | null [];
  itemBox: ItemBox;
  maxHeight: number | null;

  constructor({
    columnCount,
    columnWidth,
    columnPadding,
    rowPadding,
    itemBox,
    itemCount,
  }) {
    this.columnCount = columnCount;
    this.columnWidth = columnWidth;
    this.columnPadding = columnPadding;
    this.rowPadding = rowPadding;

    this.columnHeights = [];
    this.itemPositions = [];
    this.columnHeights[0] = Array.from({ length: columnCount }).map(x => 0);
    this.itemBox = itemBox;
    this.itemCount = itemCount;
  }

  getItemPosition(index) {
    const { positionChecked } = this.itemBox.getBox(index);
    // if we are too slow to get the position, recalculate all the items at this time
    if (positionChecked === false) {
      for (let i = 0; i < index; i++) {
        this.setItemPosition(i);
      }
    }
    if (this.itemPositions[index]) {
      return this.itemPositions[index];
    }
    return null;
  }

  setItemPosition(index) {
    const { height: itemHeight, width: itemWidth } = this.itemBox.getBox(index);

    if (this.columnHeights[index] == null || itemHeight == null) {
      this.itemPositions[index] = null;
      return;
    }

    const columnHeights = this.columnHeights[index];

    const minIndex = this.minHeightColumn(columnHeights);

    const top = columnHeights[minIndex];

    const left = minIndex * (this.columnWidth + this.columnPadding);

    const nextColumnHeights = [...columnHeights];

    const targetItemHeight = itemWidth > 0 ? this.columnWidth * (itemHeight / itemWidth) : itemHeight;

    nextColumnHeights[minIndex] = top + targetItemHeight + this.rowPadding;

    this.columnHeights[index + 1] = [...nextColumnHeights];

    this.itemPositions[index] = {
      top,
      left,
    };

    this.itemBox.checked(index);
  }

  updateLayout({
    columnCount,
    columnWidth,
    columnPadding,
    rowPadding,
    itemBox,
    itemCount,
  }) {
    this.columnCount = columnCount;
    this.columnWidth = columnWidth;
    this.columnPadding = columnPadding;
    this.rowPadding = rowPadding;

    this.columnHeights = [];
    this.itemPositions = [];
    this.columnHeights[0] = Array.from({ length: columnCount }).map(x => 0);
    this.itemBox = itemBox;
    this.itemCount = itemCount;
    this.maxHeight = null;

    // recalculate all the items
    for (let i = 0; i < this.itemCount; i++) {
      this.setItemPosition(i);
    }
  }

  placeItems() {
    if (this.itemBox.lastUpdateIndex == null) {
      return;
    }

    // recalculate all the items after the one updated
    let i = this.itemBox.lastUpdateIndex;
    while (i < this.itemCount) {
      this.setItemPosition(i);
      i += 1;
    }

    this.itemBox.lastUpdateIndex = null;
  }

  getMaxHeight() {
    if (this.columnHeights[this.itemCount]) {
      const heights = this.columnHeights[this.itemCount];
      let maxHeight = heights[0];
      for (let i = 1; i < heights.length; i++) {
        if (heights[i] > maxHeight) {
          maxHeight = heights[i];
        }
      }
      return maxHeight;
    }
    // guessed height
    return (this.itemCount / this.columnCount) * 240;
  }

  setItemCount(count) {
    this.itemCount = count;
  }

  minHeightColumn(columnHeights) : number {
    let smallest = 0;
    for (let i = 1; i < columnHeights.length; i++) {
      if (columnHeights[i] < columnHeights[smallest]) {
        smallest = i;
      }
    }
    return smallest;
  }
}
